import * as React from "react";
import type { SVGProps } from "react";
const SvgEmailShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20.22 8.771-7.003-5.363a2 2 0 0 0-2.434 0L3.782 8.771a2 2 0 0 0-.785 1.589v8.643a2 2 0 0 0 2.001 2h14.006a2 2 0 0 0 2-2V10.36a2 2 0 0 0-.784-1.589"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3.184 9.516 7.6 5.82a2 2 0 0 0 2.432 0l7.602-5.822"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.5 9.249-2 1.5-1-.75"
    />
  </svg>
);
export default SvgEmailShare;
